import { LEAD_ROUTE, LEAD_ROUTE_V2 } from 'utils/constants/url'

export const ROUTES = {
  // Core
  HOME: '/',
  DASHBOARD: 'dashboard',
  RM_CONVERSION: 'dashboard/rm-conversion',
  LEAD_STAGNATION: 'dashboard/lead-stagnation',
  /** Legacy combined dashboard path; redirects to RM_CONVERSION. */
  RM_CONVERSION_STAGNATION: 'dashboard/rm-conversion-stagnation',
  RM_EVENTS: 'dashboard/rm-events',
  LEAD_CAPTURE_QUALITY_DASHBOARD: 'dashboard/lead-capture-quality',
  AGENT_FOLLOW_THROUGH_DASHBOARD: 'dashboard/agent-follow-through',
  /** Legacy combined Lead Hygiene dashboard path; redirects to LEAD_CAPTURE_QUALITY_DASHBOARD. */
  LEAD_HYGIENE_DASHBOARD: 'dashboard/lead-hygiene',

  // Auth
  AUTH: 'auth/*',
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot-password',
  TWO_FACTOR_VERIFICATION: '2fa',
  VERIFICATION: 'verification',
  WELCOME: 'welcome',

  // Leads
  LEADS: 'leads',
  NEW_LEAD: 'newlead',
  LEAD_DETAILS: `${LEAD_ROUTE}:leadId/:leadAppointmentId?`,
  LEAD_DETAILS_V2: `${LEAD_ROUTE_V2}:leadId/:leadAppointmentId?`,
  PREVIEW_LEAD: `preview/${LEAD_ROUTE_V2}:leadId/:leadAppointmentId?`,
  MERGE_LEAD: 'lead/merge/:leadId',
  MERGE_LEAD_PREFIX: 'lead/merge',
  LEADS_IMPORT: 'leads/import',
  LEADS_HISTORY: 'leads/history',
  IMPORTS_V2: 'lead/importv2',
  IMPORTS_V2_NEW: 'lead/importv2/new',
  IMPORTS_V2_TASK: 'lead/importv2/:taskId',
  IMPORTS_V2_TASK_PREFIX: 'lead/importv2',
  LEADS_BULK_UPDATE: 'leads/bulk-update',
  LEADS_BULK_UPDATE_HISTORY: 'leads/bulk-update/history',

  // Sales & CRM
  ACCOUNTS: 'accounts',
  OPPORTUNITIES: 'opportunities',
  OPPORTUNITIES_QUOTATIONS_APPROVAL: 'opportunities/quotations/approval',
  CUSTOMERS: 'customers',
  PIPELINE: 'pipeline',
  PIPELINE_NEW: 'pipeline/new',
  PIPELINE_DETAILS: 'pipeline/:pipelineId/*',

  // Tasks & Calendar
  TASKS: 'tasks',
  CALENDAR: 'calendar',
  CALENDAR_NEW: 'calendar/new',
  CALENDAR_DETAILS: 'calendar/:calendarId/*',

  // Reports
  REPORTS: 'reports',

  // Settings & Admin
  SETTINGS: 'settings/*',
  PROFILE: 'profile',
  PASSWORD: 'password',
  EMAIL_SIGNATURE: '/email/signature',
  COMPANY_INFO: 'company-info',
  BRANCHES: 'branches',
  USERS: 'users/*',
  TEAMS: 'teams/*',
  APPROVERS: 'approvers/*',
  USER_ACTIVITY_AUDIT_LOG: 'user-activity-audit-log/*',
  PERMISSION: 'permission',
  BRANCH_SETTINGS: 'branch-settings',
  EXTERNAL_API_KEYS: 'externalapi-keys',
  PITCH_LIBRARY: 'pitch-library',
  EXTERNAL_API_DOCUMENTATION: 'externalapi-documentation',
  SALES_OBJECTIVE: 'sales-objective',
  AUTOMATION: 'automation',
  AUTOMATION_FORM: 'automation/form',

  // Custom Fields
  CUSTOM_FIELDS: 'custom-fields',
  CUSTOM_FIELDS_NEW: 'custom-fields/new',
  CUSTOM_FIELDS_DETAILS: 'custom-fields/:customFieldId/*',
  CUSTOM_FIELDS_CUSTOM_DATA: 'custom-fields/custom-data',
  CUSTOM_FIELDS_CUSTOM_LEAD_FORM: 'custom-fields/custom-lead-form',
  CUSTOM_FIELDS_CUSTOM_OPPORTUNITY_FORM: 'custom-fields/custom-opportunity-form',

  // Lead Management
  LEAD_STATUSES: 'lead-statuses',
  LEAD_SOURCE_TYPES: 'lead-source-types/*',
  LEAD_SOURCES: 'lead-sources/*',
  LEAD_CAMPAIGNS: 'lead-campaigns/*',

  // Workflows
  WORKFLOW: 'workflow/*',
  WORKFLOW_SALES: 'sales/*',
  WORKFLOW_CUSTOMIZATION: 'customization/*',
  GENERAL_WORKFLOW: 'general-workflow',

  // Catalog & Products
  PRODUCT_GROUP_DETAILS: 'product-group/*',
  BUNDLE_DETAILS: 'bundle/*',
  PRODUCT_DETAILS: 'product/*',
  SERVICE_DETAILS: 'service/*',
  ADD_ON_DETAILS: 'add-on/*',
  PRICE_DETAILS: 'price/*',
  CUSTOM_FIELD_DETAILS: 'custom-field/*',

  // CAMS Integration
  CAMS_IMPORT_FITMENTS: 'cams/import-fitments',

  USER_DETAILS: ':userId',
  TEAM_DETAILS: ':teamId/*',
  TEAM_CREATE: 'create',
  TEAM_EDIT: 'edit',
  LEAD_SOURCE_TYPE_DETAILS: ':leadSourceTypeId',
  LEAD_SOURCE_DETAILS: ':leadSourceId',
  LEAD_CAMPAIGN_DETAILS: ':leadCampaignId/*',
  CAMPAIGN_EDIT: 'edit',
  SALES_OBJECTIVE_DETAILS: ':salesObjectiveId',
  SALES_OBJECTIVE_EDIT: ':salesObjectiveId/edit',
  LEAD_STATUS_DETAILS: 'status',
  PIPELINE_TAB_EDIT_DETAILS: 'editdetails',
  PIPELINE_TAB_EDIT_STAGES: 'editstages',
  PIPELINE_TAB_AUTOMATION: 'automation',
} as const

export const ROUTE_BASE = {
  AUTH: 'auth',
  SETTINGS: 'settings',
  USERS: 'users',
  TEAMS: 'teams',
  APPROVERS: 'approvers',
  USER_ACTIVITY_AUDIT_LOG: 'user-activity-audit-log',
  LEAD_SOURCE_TYPES: 'lead-source-types',
  LEAD_SOURCES: 'lead-sources',
  LEAD_CAMPAIGNS: 'lead-campaigns',
  WORKFLOW: 'workflow',
  WORKFLOW_SALES: 'sales',
  WORKFLOW_CUSTOMIZATION: 'customization',
} as const
